// extracted by mini-css-extract-plugin
export default {"message":"UserMessage_message__S8cT2","type":"UserMessage_type__9ykSs","result":"UserMessage_result__f3p7K"};